import React from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import type { TooltipProps as AntdTooltipProps } from 'antd';
import './index.less';

export type TooltipPropsType = AntdTooltipProps

const Tooltip: React.FC<TooltipPropsType> = (props) => {
    const {
        overlayClassName,
        classNames = {},
        children,
        ...rest
    } = props;

    return (
        <AntdTooltip
            classNames={{
                root: overlayClassName,
                ...classNames
            }}
            {...rest}
        >
            <div>{children}</div>
        </AntdTooltip>
    );
};

export default Tooltip;
